import { getLocale } from '../helpers.js';
/**
 * function: formatFullTextDay
 * Pattern: EEEE
 * Example: Maandag
 */
export function formatFullTextDay({ date = new Date(), language, subsidiary, }) {
    const locale = getLocale(language, subsidiary);
    const dateFormat = new Intl.DateTimeFormat(locale, { weekday: 'long' });
    return dateFormat.format(date);
}
//# sourceMappingURL=formatFullTextDay.js.map